import { EMPTY, Subject, takeUntil } from 'rxjs';
export function takeUntilShutdown(shutdownSubscription) {
    if (shutdownSubscription.closed) {
        return () => EMPTY;
    }
    const shutdownSubject = new Subject();
    shutdownSubscription.add(() => shutdownSubject.next());
    return (source$) => source$.pipe(takeUntil(shutdownSubject));
}
export function takeUntilDisposed(disposableStack) {
    if (disposableStack.disposed) {
        return () => EMPTY;
    }
    const shutdownSubject = new Subject();
    disposableStack.defer(() => shutdownSubject.next());
    return (source$) => source$.pipe(takeUntil(shutdownSubject));
}
//# sourceMappingURL=takeUntilShutdown.js.map